import type { Definition } from "../api";

export type HistoryEntry = { at: string; field: string; from: string; to: string };

const HIDDEN = new Set(["created_at", "updated_at", "entity_id", "xero_item_code"]);

const show = (value: unknown): string => value === null || value === undefined
  ? "—"
  : typeof value === "object"
    ? JSON.stringify(value)
    : String(value);

/** Field-level diff between two snapshots of one definition, oldest first. */
export function diffDefinitions(before: Definition | null, after: Definition): HistoryEntry[] {
  const out: HistoryEntry[] = [];
  for (const key of Object.keys(after) as Array<keyof Definition>) {
    if (HIDDEN.has(key)) continue;
    const from = before ? show(before[key]) : "—";
    const to = show(after[key]);
    if (from !== to) out.push({ at: after.updated_at, field: key, from, to });
  }
  return out;
}

/** Dates on which the engine can expose an earlier definition snapshot. */
export function snapshotDates(updatedAt: string, logDays: string[]): string[] {
  const day = updatedAt.slice(0, 10);
  return Array.from(new Set(logDays.filter((date) => date < day))).sort();
}
